<template>
    
    <div class="main">
        <c-panel>
            <form-agenda :paramId="$route.params.id"></form-agenda>
        </c-panel>
    </div>
    
</template>
<script>

import formAgenda from "./form"

export default {
    methods:{

    },
    components:{ formAgenda }
}
</script>
